import React, { Component } from "react";
import ProfilePicture from "../../../ProfilePicture";
import { Link } from "redux-little-router";
import { constructUserProfilePath } from "../../../../util/index";
import { truncateText, checkIfMobile } from "../../../../util/index";
import { Comment as SemanticUIComment } from "semantic-ui-react";
import "./index.css";

class RecentComment extends Component {
  render() {
    const recentComment = this.props.recentComment;
    let commentMaxCharLength = 170;
    if (checkIfMobile()) {
      commentMaxCharLength = 80;
    }

    if (recentComment) {
      const owner = this.props.recentComment.owner;
      const profilePath = constructUserProfilePath(owner);
      return (
        <div className="recent-comment-wrapper">
          <a className="viewmore" onClick={this.props.viewPost}>
            View more comments
          </a>
          <div className="recent-comment">
            <SemanticUIComment>
              <Link href={profilePath} className="-avatar-link">
                <div className="avatar-container">
                  <ProfilePicture className="avatar" userId={owner.id} size="s" fallbackUrl={owner.picture} />
                </div>
              </Link>
              <div className="content">
                <SemanticUIComment.Content>
                  <SemanticUIComment.Author>
                    <Link className="author" href={profilePath}>
                      {owner.name}
                    </Link>
                  </SemanticUIComment.Author>
                  <SemanticUIComment.Text>
                    <p className="text">{truncateText(recentComment.content, commentMaxCharLength)}</p>
                  </SemanticUIComment.Text>
                </SemanticUIComment.Content>
              </div>
            </SemanticUIComment>
          </div>
        </div>
      );
    }

    return (
      <div className="recent-comment-wrapper">
        <p className="text">Be the first one to comment on this case</p>
      </div>
    );
  }
}

export default RecentComment;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/RecentComment/index.js